import Badges from ".";
import SkeletonLoader from "../Loader/SkeletonLoader";
import P from "../Paragraph";

type BadgeDetailsProps = {
  color: string;
  className?: string;
  badgeHeading?: string;
  text: string | JSX.Element;
  style?: any;
  textClass?: string;
  loading?: boolean;
  isBadgeLoading?: boolean;
};

const BadgeDetails = ({
  color,
  className,
  badgeHeading,
  text,
  style,
  textClass,
  loading = false,
  isBadgeLoading = false,
}: BadgeDetailsProps) => {
  return (
    <>
      {!isBadgeLoading && (
        <Badges
          color={color}
          style={style}
          className={`text-capitaliz badge ${className ? className : "b-r-4"} `}
        >
          {badgeHeading ?? text}
        </Badges>
      )}
      {loading && <SkeletonLoader className="" width={50} height={15} />}
      {badgeHeading && !loading && (
        <P className={`mb-0 f-12 ms-1 mt-1 text-capitalize ${textClass}`}>
          {text}
        </P>
      )}
    </>
  );
};

export default BadgeDetails;
